import { Entypo,FontAwesome5,MaterialCommunityIcons } from 'react-native-vector-icons';

export default function SyIcon({ name, style, solid }) {
    
    if(name === 'search' || name === 'star'|| name === 'star-half-alt' || name === 'paper-plane' || name === 'times' || name === 'heart'){
        return <FontAwesome5 name={name} style={style} solid={solid} color={style?.color}></FontAwesome5>
    }

    return <MaterialCommunityIcons name={name} style={style} solid={solid} color={style?.color}></MaterialCommunityIcons>
}